import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import { StyledSection, StyledSkeletonAccordion, StyledSkeletonAccordionList, StyledSkeletonHeader, StyledSkeletonLoading } from '../post-room-completion-feedback-step.styles';
interface LoadingSectionProps {
  skeletonCount: number;
  textWidth?: string;
}
export const LoadingSection = ({
  skeletonCount,
  textWidth = '70%'
}: LoadingSectionProps) => {
  const isDarkMode = useIsDarkMode();
  const skeletonKeys = Array.from({
    length: skeletonCount
  }, (_, i) => `skeleton-${Date.now()}-${Math.random()}-${i}`);
  return <StyledSection data-sentry-element="StyledSection" data-sentry-component="LoadingSection" data-sentry-source-file="loading-section.tsx">
      <StyledSkeletonAccordionList data-sentry-element="StyledSkeletonAccordionList" data-sentry-source-file="loading-section.tsx">
        {skeletonKeys.map(key => <StyledSkeletonAccordion key={key}>
            <StyledSkeletonHeader $isDarkMode={isDarkMode}>
              <StyledSkeletonLoading width={textWidth} height="2rem" />
              <StyledSkeletonLoading width="1.6rem" height="1.6rem" />
            </StyledSkeletonHeader>
          </StyledSkeletonAccordion>)}
      </StyledSkeletonAccordionList>
    </StyledSection>;
};